import { z } from "zod";

// Zod schemas for widget validation
export const textWidgetSchema = z.object({
  type: z.literal("text"),
  text: z.string(),
});

export const productWidgetSchema = z.object({
  type: z.literal("product"),
  product: z.object({
    id: z.string(),
    name: z.string(),
  }),
});

export const sponsorWidgetSchema = z.object({
  type: z.literal("sponsor"),
  sponsor: z.object({
    name: z.string(),
    imageName: z.string().nullable(),
    initials: z.string().nullable(),
  }),
});

export const contactWidgetSchema = z.object({
  type: z.literal("contact"),
  contact: z.object({
    id: z.string(),
    name: z.string(),
    imageName: z.string().nullable(),
    initials: z.string().nullable(),
    phone: z.string(),
  }),
});

export const chartWidgetSchema = z.object({
  type: z.literal("chart"),
  chart: z.object({
    data: z.string(),
    format: z.literal("svg"),
  }),
});

const nutritionColorSchema = z.enum(["#FFA64D", "#43BF62", "#9C3EFA"]);

export const nutritionWidgetSchema = z.object({
  type: z.literal("nutrition"),
  title: z.string(),
  calories: z.string(),
  nutrients: z.array(
    z.object({
      color: nutritionColorSchema,
      name: z.string(),
      weight: z.string(),
    })
  ),
  meals: z.array(
    z.object({
      color: nutritionColorSchema,
      name: z.string(),
      weight: z.string(),
      calories: z.string(),
    })
  ),
});

export const disclaimerWidgetSchema = z.object({
  type: z.literal("disclaimer"),
  disclaimerType: z.literal("nutrition"),
  title: z.string(),
  message: z.string(),
});

export const chatWidgetSchema = z.discriminatedUnion("type", [
  textWidgetSchema,
  productWidgetSchema,
  sponsorWidgetSchema,
  contactWidgetSchema,
  chartWidgetSchema,
  nutritionWidgetSchema,
  disclaimerWidgetSchema,
]);

// Widget validation function
export function validateWidget(
  widget: any
): widget is z.infer<typeof chatWidgetSchema> {
  try {
    chatWidgetSchema.parse(widget);
    return true;
  } catch (error) {
    console.warn("Invalid widget:", widget, "Error:", error);
    return false;
  }
}

// Widget array validation function
export function validateWidgets(
  widgets: any[]
): z.infer<typeof chatWidgetSchema>[] {
  if (!Array.isArray(widgets)) {
    console.warn("Widgets is not an array:", widgets);
    return [];
  }

  const validWidgets = widgets.filter(validateWidget);

  if (validWidgets.length !== widgets.length) {
    console.warn(
      `Filtered ${widgets.length - validWidgets.length} invalid widgets from array`
    );
  }

  return validWidgets;
}
